export interface ModuleConfig {
  id: string;
  label: string;
  description: string;
  icon: string;
  route: string;
  enabled: boolean;
  buttonLabel?: string;
}

export const MODULES_CONFIG: ModuleConfig[] = [
  {
    id: 'analise-dados',
    label: 'Análise de Dados',
    description: 'Conexões com datasets e execuções.',
    icon: 'connection',
    route: '/conexoes',
    enabled: true,
  },
  {
    id: 'monitoramento',
    label: 'Monitoramento',
    description: 'Acompanhamento de métricas.',
    icon: 'monitoramento',
    route: '/monitoramento',
    enabled: true,
  },
];
